import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import LinkIcon from "@mui/icons-material/Link";
import { ElementType } from "./types";
export var OPEN_LINK = "OPEN_LINK";
export var DEFAULT_CONTROLS = [
    ElementType.HeadingOne,
    ElementType.HeadingTwo,
    ElementType.BulletedList,
    ElementType.NumberedList,
    ElementType.Bold,
    ElementType.Italic,
    ElementType.Underline,
];
export var ALL_CONTROLS = [
    {
        label: "Bold",
        Icon: FormatBoldIcon,
        style: ElementType.Bold,
        type: "mark",
        testId: "bold-btn-wysiwyg",
    },
    {
        label: "C",
        style: ElementType.Code,
        type: "mark",
        testId: "code-btn-wysiwyg",
    },
    {
        label: "Italic",
        Icon: FormatItalicIcon,
        style: ElementType.Italic,
        type: "mark",
        testId: "italic-btn-wysiwyg",
    },
    {
        label: "Underline",
        Icon: FormatUnderlinedIcon,
        style: ElementType.Underline,
        type: "mark",
        testId: "underline-btn-wysiwyg",
    },
    {
        label: "H1",
        style: ElementType.HeadingOne,
        type: "block",
        testId: "h1-btn-wysiwyg",
    },
    {
        label: "H2",
        style: ElementType.HeadingTwo,
        type: "block",
        testId: "h2-btn-wysiwyg",
    },
    {
        label: "H3",
        style: ElementType.HeadingThree,
        type: "block",
        testId: "h3-btn-wysiwyg",
    },
    {
        label: "UL",
        Icon: FormatListBulletedIcon,
        style: ElementType.BulletedList,
        type: "block",
        testId: "ul-btn-wysiwyg",
    },
    {
        label: "OL",
        Icon: FormatListNumberedIcon,
        style: ElementType.NumberedList,
        type: "block",
        testId: "ol-btn-wysiwyg",
    },
    {
        label: "L",
        style: ElementType.Left,
        type: "block",
        testId: "left-btn-wysiwyg",
    },
    {
        label: "Link",
        Icon: LinkIcon,
        style: ElementType.Link,
        type: "entity",
        testId: "link-btn-wysiwyg",
    },
];
export var HOTKEYS = {
    "mod+b": {
        type: "mark",
        value: "bold",
    },
    "mod+i": {
        type: "mark",
        value: "italic",
    },
    "mod+u": {
        type: "mark",
        value: "underline",
    },
    "mod+`": {
        type: "mark",
        value: "code",
    },
    "mod+k": {
        type: "element",
        value: "link",
    },
};
export var ALLOWED_KEYS_AT_CHAR_LIMIT = [
    "Shift",
    "Meta",
    "Backspace",
    "ArrowLeft",
    "ArrowRight",
    "ArrowDown",
    "ArrowUp",
];
export var LIST_TYPES = [
    "numbered-list",
    "bulleted-list",
    "ol_list",
    "ul_list",
];
export var TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"];
